export const WeatherTileDetailTestIds = {
  container: 'weather-tile-detail-container',
  iconWrapper: 'weather-tile-detail-icon-wrapper',
};
